import { useState, useEffect } from 'react';
import { useAuth } from '../components/providers/AuthProvider';

interface AuthState {
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
  user: any;
}

export const useAuthState = (): AuthState => {
  const { user, loading } = useAuth();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Limpiar errores cuando el usuario cambie
    if (user) {
      setError(null);
    }
  }, [user]);

  return {
    isAuthenticated: !!user,
    isLoading: loading,
    error,
    user
  };
};

export const useAuthError = () => {
  const [error, setError] = useState<string | null>(null);

  const clearError = () => setError(null);

  const handleAuthError = (error: any) => {
    let errorMessage = 'Error de autenticación';

    if (error.code) {
      switch (error.code) {
        case 'auth/user-not-found':
          errorMessage = 'No existe una cuenta con este email';
          break;
        case 'auth/wrong-password':
          errorMessage = 'Contraseña incorrecta';
          break;
        case 'auth/email-already-in-use':
          errorMessage = 'Ya existe una cuenta con este email';
          break;
        case 'auth/weak-password':
          errorMessage = 'La contraseña debe tener al menos 6 caracteres';
          break;
        case 'auth/invalid-email':
          errorMessage = 'Email inválido';
          break;
        case 'auth/popup-closed-by-user':
          errorMessage = 'Inicio de sesión cancelado';
          break;
        case 'auth/popup-blocked':
          errorMessage = 'El popup fue bloqueado. Permite popups para este sitio';
          break;
        case 'auth/account-exists-with-different-credential':
          errorMessage = 'Ya existe una cuenta con este email usando otro método de inicio de sesión';
          break;
        default:
          errorMessage = error.message || 'Error de autenticación';
      }
    }

    setError(errorMessage);
    return errorMessage;
  };

  return {
    error,
    setError,
    clearError,
    handleAuthError
  };
};
